import { useSyncExternalStore } from 'react'

/**
 * Spec 160 (FR-016, FR-017, research D-160-14) — en dessous de cette largeur, le menu passe en colonne d'icônes : à
 * 1 024 px, ses 240 px laissaient la barre du haut et les pages déborder. La largeur minimale prise en charge est
 * 1 024 px (décision du 2026-10-11) ; aucun autre seuil.
 */
export const SEUIL_MENU_COMPLET = 1280

const REQUETE = `(min-width: ${SEUIL_MENU_COMPLET}px)`

function sAbonner(prevenir: () => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
  const mq = window.matchMedia(REQUETE)
  mq.addEventListener('change', prevenir)
  return () => mq.removeEventListener('change', prevenir)
}

function lire(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true
  return window.matchMedia(REQUETE).matches
}

/** Vrai à 1 280 px et plus ; suit le redimensionnement de la fenêtre. */
export function useEcranLarge(): boolean {
  return useSyncExternalStore(sAbonner, lire, () => true)
}
